var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskOpenMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 17.9609H4.24999C3.14542 17.9609 2.24999 17.0655 2.25 15.9609L2.25008 3.96093C2.25008 2.85636 3.14551 1.96094 4.25008 1.96094H13.2503C14.3549 1.96094 15.2503 2.85637 15.2503 3.96094V7.96094M11.2502 15.2035L15.4928 10.9608L18.3212 13.7892L14.0786 18.0319H11.2502V15.2035Z",
    stroke: "#fff",
    strokeWidth: 1.69124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskOpenMenu);
export default __webpack_public_path__ + "static/media/TaskOpenMenu.36046594eb7d6db29568782fdfe3d9b6.svg";
export { ForwardRef as ReactComponent };